export default __webpack_public_path__ + "static/media/Fierce Onslaught.17bffbb7.png";